<br />
<div style="text-align: center ">
    <h1>Solicitar Convenio Colaboración</h1>
</div>

<br />

<div class="container principal"
    style="border:0px solid #000000;background-color: white; padding-top: 10px; padding-bottom:50px">
    <form #convenioForm=ngForm>
        <div class="container principal">
            <p><b>Manual de convenio: </b> <a href="{{this.linkTexto}}" target="_blank">
                Convenio</a>.</p>     
            <br/>
            <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

                <div class="row">

                    <div class="col-lg-4"> Afiliado:</div>

                    <div class="col-lg-8">
                        <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                        </h2>

                    </div>

                </div>

            </div>



            <div *ngIf="rol != 'ROLE_AFILIADO'">

                <div class="row line">

                    <div class="col-lg-2"> </div>

                    <div class="col-lg-2">
                        <h2> Rut Afiliado </h2>
                    </div>

                    <div class="col-lg-4">

                        <input id="rutAfiliado" name="rutAfiliado" [(ngModel)]="buscador.rutAfiliado"
                            #rutAfiliado="ngModel" class="form-control" type="text" required
                            placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1"
                            pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                    </div>



                    <div class="col-lg-4">

                        <button class="btn btn-primary" id="btnvalida" (click)="buscaCodeudor(buscador.rutAfiliado,3)"
                            [disabled]="rutAfiliado.invalid">

                            Buscar

                        </button>
                        <br />
                    </div>
                    <div *ngIf="convenio.errors && convenio.touched" class="alert alert-danger">

                        <div *ngIf="convenio.errors.required"> Ingrese un afiliado. </div>

                    </div>
                </div>
                <div class="row line">

                    <div class="col-lg-4"> </div>
                    <div class="col-lg-5">
                        <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                        </h2>
                    </div>
                </div>
            </div>
            <br />

            <br />
            <div class="table-responsive" *ngIf="this.afiliado.idAfiliado>0">

                <table class="table" name="tablaCargaDental" id="tablaCargaDental">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th scope="col"> Rut </th>

                            <th scope="col"> Nombre y Apellido </th>

                            <th scope="col"> Parentesco </th>

                            <th scope="col"> Edad </th>

                            <th scope="col"> Sexo </th>

                            <th scope="col"> Seleccionar </th>
                        </tr>

                    </thead>

                    <tbody>
                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'"
                            *ngFor="let postulante of postulantes; let i = index">

                            <td style="text-align: center;"> {{postulante.rut + '-' + postulante.dv}} </td>

                            <td style="text-align: center;">{{postulante.nombres + ' ' + postulante.apellidoPaterno }}
                            </td>

                            <td style="text-align: center;"> {{postulante.parentesco}} </td>

                            <td style="text-align: center;"> {{postulante.fechaNacimiento}} </td>

                            <td style="text-align: center;"> {{postulante.sexo.nombre}} </td>

                            <td style="text-align: center;">

                                <input type="radio" name="postulante" [(ngModel)]="this.beneficiario" value="{{i}}"
                                    required>
                            </td>


                        </tr>

                    </tbody>

                </table>

            </div> <br /> <br />

            <br />
            <div class="row line">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3">
                    <p>Región</p>
                </div>

                <div class="col-lg-6">

                    <mat-select class="form-control" id="idRegion" name="idRegion" required
                        [(ngModel)]="convenio.idRegion" #idRegion="ngModel">

                        <mat-option value="0">

                            SELECCIONE....
                        </mat-option>

                        <mat-option *ngFor="let region of regiones" value="{{region.id}}">
                            {{region.nombre}}
                        </mat-option>
                    </mat-select>
                    <div *ngIf="convenio.errors && convenio.touched" class="alert alert-danger">

                        <div *ngIf="convenio.errors.required">Seleccione una región. </div>

                    </div>
                </div>
   
                <br>
            </div>
            <br />

            <br>
            <div class="row line">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3">
                    <p>  </p>
                </div>
                <div class="col-lg-1"><button class="btn btn-info"  style='width:300px;' (click)="buscaProveedor()">Buscar Convenio
                    Colaboración</button>
                </div>
            </div>
            <br/>

            <div class="row line">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3">
                    <p>Convenio </p>
                </div>
                <div class="col-lg-6">

                    <mat-select [(ngModel)]="convenio.idProveedor" class="form-control" id="idProveedor"
                        name="idProveedor" required #idProveedor="ngModel" (selectionChange)="buscarDescripcion()">

                        <mat-option value="0">

                            SELECCIONE....

                        </mat-option>

                        <mat-option *ngFor="let proveedor of proveedores" value="{{proveedor.id}}">

                            {{proveedor.nombre}}

                        </mat-option>

                    </mat-select>
                    <div *ngIf="convenio.errors && convenio.touched" class="alert alert-danger">

                        <div *ngIf="convenio.errors.required"> Seleccione un proveedor. </div>

                    </div>

                </div>
                <div class="col-lg-1"> </div>
                <div class="col-lg-1"> </div>
            </div>
            <br />


            <!--- textarea--->
            <div class="row line">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3">Descripción </div>

                <div class="col-lg-6">
                    <form-field appearance="outline" class="mat-input">

                        <textarea name="descripcion" id="descripcion" value={{convenio.descripcion}} cols="65" rows="10"
                            [disabled]="true">

                    </textarea>


                    </form-field>

                </div>

            </div>

            <!--- --->

        </div>
    </form>
    <div class="container principal ">
        <br />
        <div class="row line ">

            <div class="col-lg-5 col-sm-2 "> </div>



            <div class="col-lg-3 col-sm-1 ">
                <div *ngIf="rol !='ROLE_EJECUTIVO_CAIP' ">
                    <button class="btn btn-success " (click)="solicitar(convenioForm) ">

                        Solicitar

                    </button>
                </div>
            </div>

            <div class="col-lg-1 col-sm-1 "> </div>
            <br />
        </div>

    </div>
    <br />
</div>
<br /><br /><br />